export const EVENTS = {
  CLAIM: 'CLAIM',
  RISK_CORPO: 'RISK_CORPO',
  FEE_NOTE: 'FEE_NOTE',
  JUDGEMENT_ADD: 'JUDGEMENT_ADD',
  EXPERT_REPORT: 'EXPERT_REPORT',
  JUDGEMENT_ON_MERITS: 'JUDGEMENT_ON_MERITS',
  APPEAL_ADD: 'APPEAL_ADD',
  EXPERT_REPORT_APPEAL: 'EXPERT_REPORT_APPEAL',
  APPEAL_ON_MERITS: 'APPEAL_ON_MERITS',
  ASSIGNEMENT_LAWYER: 'ASSIGNEMENT_LAWYER',
  ASSIGNEMENT_MANAGER: 'ASSIGNEMENT_MANAGER',
  PROVISION_INTERVENANT: 'PROVISION_INTERVENANT',
  JUDICIARY_PROCESS: 'JUDICIARY_PROCESS',
  VICTIM: 'VICTIM',
  BENEFICIARY: 'BENEFICIARY',
  MANUAL_EVALUATION: 'MANUAL_EVALUATION',
  OPPOSING_PARTY: 'OPPOSING_PARTY',
  COUNCIL_EXPERT_REPORT: 'COUNCIL_EXPERT_REPORT',
  COUNCIL_POSTPONE: 'COUNCIL_POSTPONE',
  NOTICE_DEFICIENCY: 'NOTICE_DEFICIENCY',
  MISSION: 'MISSION',
  REGULATION: 'REGULATION',
  STATUS_CLAIM: 'STATUS_CLAIM',
  PRIORITY_CLAIM: 'PRIORITY_CLAIM',
  INSTRUCTION: 'INSTRUCTION',
  EXCEPTIONAL_FEE_NOTE: 'EXCEPTIONAL_FEE_NOTE',
  JUDGEMENT_ADD_DOCUMENT: 'JUDGEMENT_ADD_DOCUMENT',
  FIRM_REFERENCE: 'FIRM_REFERENCE',
  VICTIM_INCOME_CERTIFICATE: 'VICTIM_INCOME_CERTIFICATE',
  ELIGIBILITY_VICTIM: 'ELIGIBILITY_VICTIM',
  TRANSACTION: 'TRANSACTION',
  IMPORT_JUDICIARE_REPORT: 'IMPORT_JUDICIARE_REPORT',
  IMPORT_COUNCIL_REPORT: 'IMPORT_COUNCIL_REPORT',
  DRIVER: 'DRIVER',
  FRAUDE: 'FRAUDE',
  APPEAL_ADD_DOCUMENT: 'APPEAL_ADD_DOCUMENT',
  OPPOSITION: 'OPPOSITION',
  NON_ELIGIBILITY_VICTIM: 'NON_ELIGIBILITY_VICTIM',
  TRANSACTION_CONTACT: 'TRANSACTION_CONTACT',
};

export const ACTIONS = {
  PRE_OPEN: 'PRE_OPEN',
  OPEN: 'OPEN',
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  CHANGE: 'CHANGE',
  VALIDATE: 'VALIDATE',
  REJECT: 'REJECT',
  DECISION: 'DECISION',
  APPRECIATION: 'APPRECIATION',
  FIRST_VALIDATION: 'FIRST_VALIDATION',
  SECOND_VALIDATION: 'SECOND_VALIDATION',
  THIRD_VALIDATION: 'THIRD_VALIDATION',
  GENERATE: 'GENERATE',
  DO_NOT_GENERATE: 'DO_NOT_GENERATE',
};
